import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuthContext } from '../context/AuthContext';

/**
 * Real-time listener for outgoing friend requests
 * Returns pending requests sent BY the current user
 */
export function useSentRequests() {
  const { user } = useAuthContext();
  const [sentRequests, setSentRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setSentRequests([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, 'friendRequests'),
      where('from', '==', user.uid),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const results = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSentRequests(results);
        setLoading(false);
      },
      (err) => {
        console.error('Error listening to sent requests:', err);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [user]);

  return { sentRequests, loading };
}
